// extracted by mini-css-extract-plugin
export default {"title":"WebExhibistsLoading_title__veaGP","description":"WebExhibistsLoading_description__y1gJJ"};